<template>
  <v-dialog v-model="confirmationDialogOpen">
    <v-card
      class="dialog-card mx-auto"
      :text="confirmationDialogMessage"
    >
      <v-card-actions>
        <v-spacer />

        <v-btn @click="setConfirmationResponse(false)">
          No
        </v-btn>

        <v-btn @click="setConfirmationResponse(true)">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const confirmationDialogStore = useConfirmationDialogStore();
const { confirmationDialogMessage, confirmationDialogOpen } = storeToRefs(confirmationDialogStore);
const { setConfirmationResponse } = confirmationDialogStore;
</script>

<style scoped>
.dialog-card {
  max-width: 400px;
}
</style>
